import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ContentObjectListDataObject } from 'models/service';

type FeedRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  community_id?: string;
  pinned?: boolean;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
} & CursorPaginationRailsParams;

export const getFeed = async ({ config }: ConfigRequest<FeedRequest>) =>
  apiClient.get<ContentObjectListDataObject[], ApiClientResponse<ContentObjectListDataObject[]>>(
    routes.contentObjects.feed,
    config,
  );
